import gql from 'graphql-tag';
import FieldsReport from 'graphql/fields/FieldsReport'

export default gql(`
	query report( $guid: String! ) {
		report( guid: $guid ) {
			${ FieldsReport }
		}
	}
`);

